import {easeInOutCubic} from 'js-easing-functions';

// INPUT:

// value
// array of numbers
// array of array
// array of objects

const tween = function (component, prop, key, start, end, duration) {
  switch (typeof start) {
    case 'number':
      tweenFunction (component, prop, key, start, end, duration);
      break;
    case 'object':
      iterate (component, prop, key, start, end, duration);
      break;
  }

  function iterate (component, prop, key, start, end, duration) {
    for (var i = 0; i < start.length; i++) {
      if (start[i].length >= 0) {
        // Array of array
        for (var j = 0; j < start[i].length; j++) {
          tweenFunction (
            component,
            prop,
            key,
            start[i][j],
            end[i][j],
            duration,
            i,
            j
          );
        }
      } else {
        // Array of objects
        tweenFunction (component, prop, key, start[i], end[i], duration, i);
      }
    }
  }
};

const tweenFunction = function (
  component,
  prop,
  key = 'value',
  start,
  end,
  duration,
  index = null,
  secondIndex = null
) {
  let startTime = Date.now ();
  let anim;
  function loop () {
    var t = Date.now () - startTime;
    if (t <= duration) {
      if (index !== null) {
        // Array
        if (typeof start === 'number') {
          if (secondIndex !== null) {
            // Array of array
            let value = easeInOutCubic (t, start, end - start, duration);
            component[prop][index].splice ([secondIndex], 1, value);
          } else {
            // Array
            let value = easeInOutCubic (t, start, end - start, duration);
            component[prop].splice (index, 1, value);
          }
        } else {
          // Array of Objects
          let value = easeInOutCubic (
            t,
            start[key],
            end[key] - start[key],
            duration
          );
          let item = component[prop][index];
          item[key] = value;

          component[prop].splice (index, 1, item);
        }
      } else {
        // Number
        component[prop] = easeInOutCubic (t, start, end - start, duration);
      }
      anim = requestAnimationFrame (loop);
    } else {
      cancelAnimationFrame (anim);
    }
  }
  anim = requestAnimationFrame (loop);
};

export {tween};
